export default __webpack_public_path__ + "static/media/action_button_spinner.5482e5da.svg";